import { useContext } from 'react';
import { SubscriptionContext } from '../providers/SubscriptionProvider';

export default () => useContext(SubscriptionContext);
